<ul data-test-id="tile-filter-tab">
  @for (option of options; track option) {
    <li ><button (click)="select(option.value)" [class.active]="option.value === selectedValue">{{option.name | async}}</button></li>
  }
</ul>
